import React from 'react';
import Title from 'lib/src/components/typography/Title';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import { challengeGroupsBreadcrumb } from '../../constants/breadcrumbItems';
import ChallengeGroupsTable from './ChallengeGroupsTable';
import { useParams } from 'react-router';
import DeleteChallengeGroupModal from './DeleteChallengeGroupModal';
import EditChallengeGroupModal from './EditChallengeGroupModal';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import LinkButton from '@components/button/LinkButton';
import CreateChallengeGroupModal from './CreateChallengeGroupModal';

const ChallengeGroups: React.FC = () => {
    const { id, action } = useParams<ParamTypes>();

    return (
        <>
            <Breadcrumb items={challengeGroupsBreadcrumb} />
            <CreateHeader>
                <Title>Challenge Groups</Title>
                <LinkButton color="green" icon="plus" href="/challenge-groups/create">
                    Create
                </LinkButton>
            </CreateHeader>
            <ChallengeGroupsTable />
            {action === 'delete' && <DeleteChallengeGroupModal id={+id} />}
            {action === 'edit' && <EditChallengeGroupModal id={+id} />}
            {action === 'create' && <CreateChallengeGroupModal />}
        </>
    );
};

interface ParamTypes {
    id: string;
    action: string;
}
export default ChallengeGroups;
